import { useAtomValue, useSetAtom } from "jotai";
import { useCallback } from "react";
import { widgetMenuOptionsAtom, widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import { applyValue } from "../../lib";
import { setNewOptions } from "../../lib/setNewOptions";
import type { ActiveSubMenuState, SetActiveSubMenu } from "../../types";
import { SubMenu } from "../SubMenu/SubMenu";
import { ArrowEndContent } from "./ArrowEndContent";

interface ArrowEndMenuProps {
    activeSubMenu: ActiveSubMenuState;
    setActiveSubMenu: SetActiveSubMenu;
}

export function ArrowEndMenu({ activeSubMenu, setActiveSubMenu }: ArrowEndMenuProps) {
    const options = useAtomValue(widgetMenuOptionsByNameAtom(activeSubMenu.name));
    const setWidgetMenuOptions = useSetAtom(widgetMenuOptionsAtom);

    const handleButtonClick = useCallback(
        (type: string) => {
            const side = activeSubMenu.name.toLowerCase().includes("first") ? "first" : "last";

            const setNewArrowEndOptions = setNewOptions({
                name: activeSubMenu.name,
                setWidgetMenuOptions,
            });

            function handleClose() {
                setActiveSubMenu(null);
            }

            applyValue({
                options,
                value: { side, endType: type },
                setNewOptions: setNewArrowEndOptions,
                handleClose,
            });
        },
        [activeSubMenu, options, setWidgetMenuOptions, setActiveSubMenu],
    );

    return (
        <SubMenu padding={8} activeSubMenu={activeSubMenu}>
            <ArrowEndContent onClick={handleButtonClick} />
        </SubMenu>
    );
}
